import { graphql } from 'react-apollo'
import { Layout, Form, Button, notification, Divider, Table, DatePicker } from 'antd'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import moment from 'moment'
import XLSX from 'xlsx'

import Footer from '../components/Footer'
import Navbar from '../components/Navbar'
import TrackingsQuery from '../graphql/queries/trackings'

import '../css/form.css'

const { Content } = Layout
const FormItem = Form.Item
const { RangePicker } = DatePicker

class ReportTracking extends Component {
  state = {
    start_date : '',
    end_date : '',
    submitting: false,
    trackings: [],
    status : 'ready',
  }
  loadLabels = async () => {
    this.setState({ submitting: true })
    this.setState({ status: 'processing' })
    const start_d = this.state.start_date
    const end_d = this.state.end_date
    try {
      if (start_d && end_d) {
        let { data: { trackings } } = await this.props.trackings.refetch({})
        trackings = trackings.filter(tracking => ( moment(tracking.scannedAt).format('YYYY-MM-DD HH:mm:ss') >= start_d && moment(tracking.scannedAt).format('YYYY-MM-DD HH:mm:ss') <= end_d) )
        this.setState({ trackings })
      }
    } catch (err) {
      notification.error({
        message: 'Error',
        description: err.message,
      })
    } finally {
      this.setState({ submitting: false })
      this.setState({ status: 'complete' })
    }
  }
  handleInputChange = (e) => {
    if(e[0] !== undefined){
      this.setState({ start_date: e[0].format('YYYY-MM-DD 00:00:00') })
      this.setState({ end_date: e[1].format('YYYY-MM-DD 23:59:59') })  
    }
  }
  exportExcel = async () => {
    const { trackings } = this.state
    const excelData = trackings.map((tracking) => {
      return {
        Tracking: tracking.code,
        Carrier: tracking.carrier,
        Date: moment(tracking.scannedAt).format('YYYY-MM-DD HH:mm:ss'),
        App: tracking.label.app,
        Group: tracking.label.group,
        Recipient: tracking.label.recipient,
        Address: tracking.label.address,
      }
    })
    const workbook = XLSX.utils.book_new()
    const worksheet = XLSX.utils.json_to_sheet(excelData)
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1')
    XLSX.writeFile(workbook, `tracking-${moment().format('YYYYMMDDHHmmSS')}.xlsx`)
  }
  render() {
    const { getFieldDecorator } = this.props.form
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
    }
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 4,
        },
      },
    }
    const columns = [
      {
        title: 'Tracking',
        dataIndex: 'code',
        key: 'code',
      },
      {
        title: 'Carrier',
        dataIndex: 'carrier',
        key: 'carrier',
      },
      {
        title: 'Date',
        key: 'scannedAt',
        render: record => moment(record.scannedAt).format('YYYY-MM-DD HH:mm:ss')
      },
      {
        title: 'App',
        key: 'app',
        render: record => record.label.app,
      },
      {
        title: 'Group',
        key: 'group',
        render: record => record.label.group,
      }
    ]
    return (
      <Layout>
        <Navbar selected="report:1" />
        <Content style={{ padding: '0 20px' }}>
          <div style={{ background: '#fff', padding: 24, minHeight: 'calc(100vh - 64px - 69px)' }}>
            <Form>
              <FormItem
                {...formItemLayout}
                label="Label id"
              >
                {getFieldDecorator('id', {
                  initialValue: '',
                  rules: [{ required: true, message: 'Please input date!' }],
                })(
                  <RangePicker onChange={this.handleInputChange}/>
                )}
              </FormItem>
              <FormItem {...tailFormItemLayout}>
                <Button type="primary" style={{ marginRight: '10px' }} onClick={this.loadLabels} disabled={this.state.submitting}>Search</Button><br />
                Status : { this.state.status }
              </FormItem>
            </Form>
            <Divider />
            {this.state.trackings.length > 0 ? (
              <div>
                <Button
                  type="primary"
                  onClick={this.exportExcel}
                  style={{ float: 'right', marginRight: '10px' }}
                >
                  Export excel
                </Button>
                <h2>trackings <small>( Count : { this.state.trackings.length } )</small></h2>
                {<Table
                  rowKey="_id"
                  dataSource={this.state.trackings}
                  columns={columns}
                  pagination={{ pageSize: 50 }}
                  size="small"
                /> }
              </div>
            ) : null}
          </div>
        </Content>
        <Footer />
      </Layout>
    )
  }
}
ReportTracking.propTypes = {
  form: PropTypes.shape(),
}
ReportTracking.defaultProps = {
  form: {},
}

export default graphql(TrackingsQuery, { name: 'trackings', options: { variables: { _id: '' } } })(Form.create()(ReportTracking))



// WEBPACK FOOTER //
// ./src/pages/ReportTracking.js